// extracted by mini-css-extract-plugin
export var courseMaterialsPack = "CourseMaterialsPack-module--courseMaterialsPack--1ldPf";
export var courseMaterial = "CourseMaterialsPack-module--courseMaterial--r5CXI";
export var lessonResourcesWrapper = "CourseMaterialsPack-module--lessonResourcesWrapper--2uB77";